const requireModule = require.context('.', true, /\.js$/); // extract js files inside modules folder
const modules = {};

requireModule.keys().forEach(fileName => {
  if (fileName == './index.js' || fileName.indexOf('format') > 0) return; // reject files

  const moduleName = createModuleNameFromPath(fileName);

  modules[moduleName] = requireModule(fileName).default;
});

function createModuleNameFromPath(str) {
  // Remove './' if it exists
  const cleanPath = str.replace(/^\.\//, '');

  // Split the path and extension
  const [path, ext] = cleanPath.split('.');

  // Transform the path (split by '/' and join with '_')
  const transformedPath = path.split('/').join('_').replace(/-/g, '_');

  // folders containing index.js take directory name as module name
  const stripIndex = transformedPath.replace('_index', '');

  return stripIndex;
}

export default modules;